var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trade_stat_container__platforms"},_vm._l((_vm.platforms),function(platform){return _c('span',{key:platform.code,class:{active:_vm.value===platform.code},on:{"click":function($event){return _vm.eventClick(platform.code)}}},[_vm._v(" "+_vm._s(platform.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }